export const calculateTimeByOverMinutesFromHoursMinutesObj = ({ hours, minutes }) => {
  let h = hours;
  let m = minutes;

  if (m > 60) {
    const floored = Math.floor(m / 60);

    if (floored > 1) {
      h += floored;
      m -= 60 * floored;
    } else {
      h += 1;
      m -= 60;
    }
  }

  return { hours: h, minutes: m };
};

export const generateHoursMinutesObjFromTimeArray = (time) => {
  const [,, seconds = 0] = time;
  let [hours = 0, minutes = 0] = time;

  if (seconds >= 10) {
    minutes += 1;
  }

  if (minutes >= 60) {
    hours += 1;
    minutes -= 60;
  }

  return { hours, minutes };
};

export const calculateTotalTimeHoursMinutesSecondsArray = ({
  items,
  timeKey = 'estimatedTime',
}) => (items || [])
  .reduce((acc, { [timeKey]: t }) => {
    const time = t.split(':');

    let hours = parseInt(time[0], 10) + acc[0];
    let minutes = parseInt(time[1], 10) + acc[1];

    hours += minutes / 60;
    minutes %= 60;

    let seconds = parseInt(time[2], 10) + acc[2];

    minutes += seconds / 60;
    seconds %= 60;

    return [
      parseInt(hours, 10),
      parseInt(minutes, 10),
      parseInt(seconds, 10),
    ];
  }, [0, 0, 0]);

export const calculateTotalTime = ({
  timeKey = 'estimatedTime',
  items,
}) => calculateTimeByOverMinutesFromHoursMinutesObj(
  generateHoursMinutesObjFromTimeArray(
    calculateTotalTimeHoursMinutesSecondsArray({ items, timeKey }),
  ),
);

const generateTimeString = (time, marker) => (time ? `${time}${marker}` : '');

export const generateTimeStrFromHoursMinutesObj = ({ hours, minutes }) => {
  if (!hours && !minutes) {
    return '-';
  }

  return `${generateTimeString(hours, 'h')} ${generateTimeString(minutes, 'm')}`;
};
